export default __webpack_public_path__ + "static/media/1503.ca960b7b.png";